var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h3",
        {
          staticClass: "txt-center mb-2",
          class: _vm.$store.getters["isMobile"]
            ? "txt-title-small"
            : _vm.$store.getters["isLaptop"]
            ? "txt-title"
            : "txt-title-large"
        },
        [_c("strong", [_vm._v("Welcome Back!")])]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "txt-center txt-muted",
          class: _vm.$store.getters["isMobile"]
            ? "txt-body pb-4"
            : "txt-heading-small pb-4 mb-4"
        },
        [_vm._v("Let’s get you back in.")]
      ),
      _vm._v(" "),
      _c(
        "b-form",
        {
          staticClass: "inner-form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c("form-control-text", {
            staticClass: "mt-4",
            class: _vm.$store.getters["isTablet"] ? "mb-3" : "mb-4",
            attrs: {
              state: _vm.$v.form.email.$error ? false : null,
              id: "loginEmail",
              placeholder: "Email address",
              label: "Email",
              required: "",
              type: "email"
            },
            on: {
              change: function($event) {
                return _vm.$v.form.email.$touch()
              }
            },
            model: {
              value: _vm.form.email,
              callback: function($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email"
            }
          }),
          _vm._v(" "),
          _c("form-control-text", {
            ref: "password",
            attrs: {
              state: _vm.$v.form.password.$error ? false : null,
              id: "loginPass",
              placeholder: "Password",
              label: "Password",
              required: "",
              type: "password",
              showPasswordCheck: ""
            },
            on: {
              change: function($event) {
                return _vm.$v.form.password.$touch()
              }
            },
            model: {
              value: _vm.form.password,
              callback: function($$v) {
                _vm.$set(_vm.form, "password", $$v)
              },
              expression: "form.password"
            }
          }),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "ml-auto",
              attrs: { to: "/login/forgot", variant: "link-text mt-1" }
            },
            [_vm._v("Forgot password?")]
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            { attrs: { show: !!_vm.error, fade: "", variant: "warning mb-0" } },
            [
              _c(
                "svg",
                {
                  staticClass: "alert-icon icon-sm",
                  attrs: { viewBox: "0 0 24 24" }
                },
                [
                  _c("use", {
                    attrs: { "xlink:href": "#icon-warning-triangle-color" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "alert-content" }, [
                _c("span", { staticClass: "txt-body" }, [
                  _vm._v(_vm._s(_vm.error))
                ]),
                _c("br"),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "alert-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onReset()
                      }
                    }
                  },
                  [_c("b", [_vm._v("Try again?")])]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mb-2",
              class: _vm.$store.getters["isTablet"] ? "mt-3" : "mt-4",
              attrs: {
                id: "loginBtn",
                disabled: _vm.$v.$invalid || _vm.loading,
                block: "",
                type: "submit",
                variant: "primary"
              }
            },
            [_vm._v("\n      Sign In\n    ")]
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "or my-4" }),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mt-2",
              class: _vm.$store.getters["isTablet"] ? "mb-3" : "mb-4",
              attrs: {
                href: _vm.urlGoogle,
                target: _vm.target,
                id: "googleBtn",
                block: "",
                variant: "google"
              }
            },
            [
              _c(
                "svg",
                { staticClass: "btn-left", attrs: { viewBox: "0 0 24 24" } },
                [_c("use", { attrs: { "xlink:href": "#icon-google-logo" } })]
              ),
              _vm._v("\n      Sign In with Google\n    ")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "txt-body txt-center auth-page-cta with-arrow-bottom" },
        [
          _c("span", { staticClass: "txt-muted" }, [
            _vm._v("Don’t have an account?")
          ]),
          _vm._v(" "),
          _c(
            "b-btn",
            { attrs: { variant: "link-text ml-1", to: { name: "Register" } } },
            [
              _c("b", { staticClass: "txt-primary" }, [
                _vm._v("Sign Up for free!")
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }